export const aboutData = {
  heroImage: "https://readdy.ai/api/search-image?query=Professional%20team%20of%20HVAC%20engineers%20and%20technicians%20working%20together%20in%20a%20modern%20industrial%20facility%20with%20precision%20equipment%20and%20organized%20workspace&width=1920&height=600&seq=vc-abt-12&orientation=landscape",
  companyImage: "https://readdy.ai/api/search-image?query=Modern%20industrial%20HVAC%20company%20headquarters%20building%20exterior%20with%20professional%20signage%20and%20clean%20corporate%20architecture%20in%20daylight&width=900&height=600&seq=vc-abt-13&orientation=landscape",
  values: [
    {
      icon: "ri-shield-check-line",
      title: "Compromiso",
      description:
        "Nos comprometemos con cada proyecto como si fuera nuestro, garantizando resultados de calidad y la satisfacción total de nuestros clientes.",
    },
    {
      icon: "ri-lightbulb-flash-line",
      title: "Innovación",
      description:
        "Adoptamos tecnologías de vanguardia como IoT e IA para ofrecer soluciones inteligentes que optimizan el rendimiento y la eficiencia energética.",
    },
    {
      icon: "ri-team-line",
      title: "Experiencia",
      description:
        "Más de 15 años de trayectoria nos respaldan en la implementación de sistemas HVAC y eléctricos en proyectos de gran escala.",
    },
    {
      icon: "ri-hand-heart-line",
      title: "Servicio",
      description:
        "Brindamos atención personalizada desde la cotización hasta el mantenimiento post-instalación, asegurando relaciones de largo plazo.",
    },
  ],
};